import { Player } from '@lottiefiles/react-lottie-player';

import loadRipple from '@/assets/logo-adf-forest-load-ripple.json';

const TreeLogoRippleAnimation = () => {
  return (
    <Player
      src={loadRipple}
      background='transparent'
      speed={1}
      style={{ width: 'full', height: '160px' }}
      loop
      autoplay
    />
  );
};

export default TreeLogoRippleAnimation;
